import React, { Ref, forwardRef } from "react";
import {
  StyledTextareaWrapper,
  StyledTextarea,
  StyledEndAndornment,
} from "./Textarea.styled";
import { TextareaAutosizeProps } from "@mui/material";
import { WithTesting } from "../../types";

export interface TextAreaProps extends TextareaAutosizeProps {
  isError?: boolean;
  isActive?: boolean;
  endAdornment?: React.ReactNode;
}

const Textarea = forwardRef(
  (
    {
      isError,
      dataTestId,
      endAdornment,
      minRows = 5,
      maxRows = 5,
      ...props
    }: TextAreaProps & WithTesting,
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    return (
      <StyledTextareaWrapper>
        <StyledTextarea
          data-testid={dataTestId}
          ref={ref}
          minRows={minRows}
          maxRows={maxRows}
          isError={isError}
          isEmpty={!props.value}
          endAdornment={Boolean(endAdornment)}
          {...props}
        />
        {Boolean(endAdornment) && (
          <StyledEndAndornment>{endAdornment}</StyledEndAndornment>
        )}
      </StyledTextareaWrapper>
    );
  },
);

export default Textarea;
